<template>
    <div v-if="options">
        <div v-for="(optList, opt) in options" v-bind:key="opt">
            <div :class="`${optListItem.error && 'error'} option input-group`" v-for="(optListItem, i) in optList" v-bind:key="opt + optListItem.name ? optListItem.name : (optListItem.header || optListItem.param)">
				<span v-if="optListItem.hide"></span>
				<span v-else>
					<label>{{optListItem.displayName || optListItem.name || optListItem.header || optListItem.param}}{{optListItem.required ? '*' : ''}}
						<small v-if="optListItem.link"><a :href="optListItem.link.uri" target="_blank">{{optListItem.link.text || 'Link'}}</a></small>
					</label>
					<small class="input-link" v-if="optListItem.secret && toggleSecretUpdate"><a @click="toggleSecretUpdate($event, opt, i)" target="_blank">{{optListItem.disabled ? 'Replace Secret Value' : 'Cancel' }}</a></small>
					<span v-if="optListItem.schema && optListItem.schema.type === 'number'">
						<input v-if="model" type="number" step="any" :disabled="optListItem.disabled ? true : false" :required="optListItem.required ? true : false" @input="updateFunction($event, opt, i)" :placeholder="optListItem.description && optListItem.description" v-model="model.options[opt][i].value">
						<input v-else type="number" step="any" :disabled="optListItem.disabled ? true : false" :required="optListItem.required ? true : false" @input="updateFunction($event, opt, i)" :placeholder="optListItem.description && optListItem.description">
					</span>
					<!-- context inputOptions -->
					<span v-else-if="optListItem.inputType === 'SELECT' && optListItem.inputOptions && optListItem.inputOptions.context && installContext">
						<select v-if="model" v-model="model.options[opt][i].value" @change="updateFunction($event, opt, i)" :required="optListItem.required ? true : false">						
							<option v-for="selection in installContext[optListItem.inputOptions.context.contextKey][optListItem.inputOptions.context.selectionList]" v-bind:value="selection[optListItem.inputOptions.context.selectionValue]" v-bind:key=selection[optListItem.inputOptions.context.selectionKey]>
								{{ selection[optListItem.inputOptions.context.selectionDisplay] }}
							</option>
						</select>
						<select v-else @change="updateFunction($event, opt, i)" :required="optListItem.required ? true : false">
							<option disabled value='' :selected="true">Choose</option>
							<option v-for="selection in installContext[optListItem.inputOptions.context.contextKey][optListItem.inputOptions.context.selectionList]" v-bind:value="selection[optListItem.inputOptions.context.selectionValue]" v-bind:key="selection[optListItem.inputOptions.context.selectionKey]">
								{{ selection[optListItem.inputOptions.context.selectionDisplay] }}
							</option>
						</select>
					</span>
					<!-- select inputOptions -->
					<span v-else-if="optListItem.inputType === 'SELECT' && optListItem.inputOptions && optListItem.inputOptions.selection && optListItem.inputOptions.selection.options">
						<select v-if="model" v-model="model.options[opt][i].value" @change="updateFunction($event, opt, i)" :required="optListItem.required ? true : false">						
							<option v-for="selection in optListItem.inputOptions.selection.options" v-bind:value="selection.value" v-bind:key=selection.key>
								{{ selection.key }}
							</option>
						</select>
						<select v-else @change="updateFunction($event, opt, i)" :required="optListItem.required ? true : false">
							<option disabled value='' :selected="true">Choose</option>
							<option v-for="selection in optListItem.inputOptions.selection.options" v-bind:value="selection.value" v-bind:key="selection.key">
								{{ selection.key }}
							</option>
						</select>
					</span>
					<!-- select multi search -->
					<span v-else-if="optListItem.inputType === 'MULTI_SEARCH_SELECT' && optListItem.inputOptions && optListItem.inputOptions.selection && optListItem.inputOptions.selection.options">
						<v-select v-if="model" multiple v-model="model.options[opt][i].value" :options="optListItem.inputOptions.selection.options" :reduce="item => item.value" label="key" />
						<v-select v-else multiple :options="optListItem.inputOptions.selection.options" :reduce="item => item.value" label="key" @input="updateFunction($event, opt, i)" />
					</span>
					<!-- select bucket -->
					<span v-else-if="optListItem.inputType === 'SELECT' && optListItem.inputOptions && optListItem.inputOptions.bucket">
						<select v-if="model" v-model="model.options[opt][i].value" @change="updateFunction($event, opt, i)" :required="optListItem.required ? true : false">	
							<option v-for="bucket in buckets" v-bind:value="bucket[optListItem.inputOptions.bucket.value || 'id' ]" v-bind:key=bucket.id>
								{{ bucket[optListItem.inputOptions.bucket.display || 'name' ] }}
							</option>
						</select>
						<select v-else @change="updateFunction($event, opt, i)" :required="optListItem.required ? true : false">
							<option disabled value='' :selected="true">Choose</option>
							<option v-for="bucket in buckets" v-bind:value="bucket[optListItem.inputOptions.bucket.value || 'id' ]" v-bind:key=bucket.id>
								{{ bucket[optListItem.inputOptions.bucket.display || 'name' ] }}
							</option>
						</select>
					</span>
					<!-- default -->
					<span v-else>
						<input v-if="model" type="text" :disabled="optListItem.disabled ? true : false" :required="optListItem.required ? true : false" @input="updateFunction($event, opt, i)" :placeholder="optListItem.description && optListItem.description" v-model="model.options[opt][i].value">
						<input v-else type="text" :disabled="optListItem.disabled ? true : false" :required="optListItem.required ? true : false" @input="updateFunction($event, opt, i)" :placeholder="optListItem.description && optListItem.description">
					</span>
					<span v-if="showHelper">
						<div class="input-helper" v-if="optListItem.description">{{optListItem.description}}</div>
					</span>
					<span v-if="optListItem.error"><i class="fas fa-exclamation-triangle"></i> {{optListItem.error}}</span>
				</span>
            </div>
        </div>
    </div>
</template>

<script>
	import { mapGetters } from 'vuex';
    import { validate } from '../utils/validator';

	export default {
		name: 'TemplateOptions',
		props: {
            options: Object,
			updateFunction: Function,
			installContext: Object,
            toggleSecretUpdate: Function,
            showHelper: Boolean,
            model: Object
		},
		computed: {
			...mapGetters([
				'buckets'
			]),
		}
	};
</script>

<style>
	.input-group input{
		border-radius: 0;
	}

	.input-group.error{
		position: relative;
		left: -16px;
		padding: 15px;
		right: 100px;
		background-color: #FFE1E1;
		width: 100%;
	}

	.input-group.error input,
	.input-group.error input[type=number]{
		border: 1px solid #C83F3F;
		background-color: #FFE1E1;
		color:  #C83F3F;
	}

	.error > span:last-of-type{
		display:block;
		margin-top:5px;
		/* font-weight:bold; */
		color:  #C83F3F;

	}
	label{
		display: block;
	}

    .input-group{
		margin: 15px auto;
		position:relative;
	}

	.input-group .input-link{
		position: absolute;
		top:2em;
		right:5px;
		cursor: pointer;
	}

	.input-group{
		margin: 15px auto;
	}

	.input-group input[type = radio],
	.input-group input[type = checkbox]{
		vertical-align: middle;
		margin-right:5px;
	}
	.input-helper{
		margin: 0 0 15px;
		font-size:12px;
		color: #555;
	}
	label.radio{
		margin-bottom: 5px;
	}

    .input-group input[type = text],
    .input-group input[type = number],
	.input-group select {
		display:block;
		width:100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/TemplateOptions.vue